// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询部门列表 GET /api/v1/dashboard/department */
export async function DashboardDepartmentControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardDepartmentControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputDepartmentDtoArray>(
    "/api/v1/dashboard/department",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建部门 POST /api/v1/dashboard/department */
export async function DashboardDepartmentControllerCreateV1(
  body: MyApi.CreateDepartmentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputDepartmentDto>(
    "/api/v1/dashboard/department",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取部门详情 GET /api/v1/dashboard/department/${param0} */
export async function DashboardDepartmentControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardDepartmentControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputDepartmentDto>(
    `/api/v1/dashboard/department/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新部门 PUT /api/v1/dashboard/department/${param0} */
export async function DashboardDepartmentControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardDepartmentControllerUpdateV1Params,
  body: MyApi.UpdateDepartmentDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputDepartmentDto>(
    `/api/v1/dashboard/department/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除部门 DELETE /api/v1/dashboard/department/${param0} */
export async function DashboardDepartmentControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardDepartmentControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/dashboard/department/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 获取组织架构树 GET /api/v1/dashboard/department/tree */
export async function DashboardDepartmentControllerTreeV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputDepartmentTreeDtoArray>(
    "/api/v1/dashboard/department/tree",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}
